<template>
  <div>
    <v-container>
      <h1>DAC6 Registration</h1>
      <v-row>
        <v-col>Client (No.){{ client.number }}</v-col>
      </v-row>
      <v-row>
        <v-expansion-panels v-model="expannel" active-class="my-2">
          <v-expansion-panel class="questionnaire-overview">
            <v-expansion-panel-header class="px-2 d-flex background6">
              <h2 class="questionnaire-title">Questionnaire: '{{ activeQuestionnaire.questionnaire.name }}'</h2>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div
                v-for="(subject, i) in activeQuestionnaire.questionnaire.questionSubjects"
                :key="i"
                class="question-subject-wrapper my-4"
              >
                <div class="subject-header background6">
                  <h3 class="pa-2">{{ subject.name }}</h3>
                </div>
                <div v-for="(q, i) in subject.questions" :key="i">
                  <question
                    :ref="'questref' + i"
                    :question="q"
                    :giveanswerarr="givenAnswerArr"
                    :index="i"
                    @next-question="insertNextQuestion"
                    @last-question="insertLastQuestion"
                    @update-explanation="updateExplanation"
                    :disabled="user.roles.indexOf('User') !== -1 && activeQuestionnaire.status == 'Done'"
                  />
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
      <v-row class="d-flex my-6 questionnaire-footer" no-gutters>
        <v-col class="d-flex">
          <v-btn
            v-if="activeQuestionnaire.status != 'In review'"
            depressed
            height="40px"
            color="bdoRed white--text"
            class="text-none mr-2"
            :disabled="!allowFinish || (user.roles.indexOf('User') !== -1 && activeQuestionnaire.status == 'Done')"
            @click="saveQuestionnaire('finish')"
          >
            Finish
          </v-btn>
          <v-btn
            depressed
            height="40px"
            color="bdoRed white--text"
            class="text-none mr-2"
            @click="saveQuestionnaire('save')"
            :disabled="user.roles.indexOf('User') !== -1 && activeQuestionnaire.status == 'Done'"
          >
            Save
          </v-btn>
        </v-col>
        <v-col class="d-flex review">
          <v-btn
            v-if="activeQuestionnaire.status == 'In review'"
            depressed
            height="40px"
            color="bdoBlack white--text"
            class="text-none mr-2"
            @click="endReviewModal = true"
          >
            End review
          </v-btn>
          <v-btn
            v-if="activeQuestionnaire.status == 'Open'"
            depressed
            height="40px"
            color="bdoBlack white--text"
            class="text-none mr-2"
            :disabled="!reviewers || reviewers.length === 0"
            @click="reviewModal = true"
          >
            Request review
          </v-btn>
          <v-btn
            v-if="activeQuestionnaire.status == 'Done'"
            depressed
            height="40px"
            color="bdoBlack white--text"
            class="text-none mr-2"
            @click="toReport()"
          >
            Back to report
          </v-btn>
          <v-btn depressed height="40px" color="bdoBlack white--text" class="text-none" @click="toOverview()">
            Back to overview
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="reviewModal" top="220" max-width="460" persistent>
      <v-card>
        <v-card-title class="modal-title">
          <h3>Request review</h3>
        </v-card-title>
        <v-card-text class="modal-content">
          <v-select
            class="px-0"
            v-model="selectedReviewer"
            :items="reviewers"
            label="Select reviewer"
            outlined
            hide-details
            item-text="name"
            item-value="id"
            return-object
            :disabled="selectingReviewer"
            :clearable="true"
            appen
          />
        </v-card-text>

        <v-card-actions class="pt-4">
          <v-spacer></v-spacer>
          <v-btn
            class="primary-btn"
            :loading="selectingReviewer"
            :disabled="!selectedReviewer"
            @click="selectReviewer()"
          >
            Request review
          </v-btn>
          <v-btn
            class="secondary-btn white--text elevation-0"
            :disabled="selectingReviewer"
            @click="reviewModal = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="endReviewModal" top="220" max-width="460" persistent>
      <v-card>
        <v-card-title class="modal-title">
          <h3>End review</h3>
        </v-card-title>
        <v-card-text class="modal-content">
          <p>Are you sure you want to end the review?<br />The questionnaire will be saved!</p>
        </v-card-text>

        <v-card-actions class="pt-4">
          <v-spacer></v-spacer>
          <v-btn class="primary-btn" :loading="endingReview" @click="endReview()">
            Yes
          </v-btn>
          <v-btn class="secondary-btn white--text elevation-0" :disabled="endingReview" @click="endReviewModal = false">
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import helpers from '@/plugins/helpers'
import config from '@/config'
import question from './components/question.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    question
  },
  data: () => ({
    fetchedQuestionnaire: {},
    activeQuestionnaire: {
      id: null,
      status: '',
      questionnaire: {
        name: '',
        numberOfQuestions: null,
        questionnaireCode: '',
        questionSubjects: []
      }
    },
    currentQuestionsIds: [],
    givenAnswerArr: [],
    showAfterQuestionArr: [],
    client: {
      id: 0,
      number: 1234
    },
    expannel: 0,
    componentKey: 0,
    reviewModal: false,
    endReviewModal: false,
    reviewers: [],
    selectedReviewer: {},
    selectingReviewer: false,
    endingReview: false,
    allowFinish: false,
    wrongRole: false,
    questionnaireDisabled: false,
    autoSaveInterval: null
  }),
  computed: {
    ...mapGetters({
      user: 'general/user',
      countrycode: 'general/countrycode'
    })
  },
  watch: {
    activeQuestionnaire: {
      deep: true,
      handler() {}
    }
  },
  mounted() {
    this.getShowAfterData()
    this.getQuestionnaireData()
    this.getReviewers()
    this.autoSave()
  },
  beforeDestroy() {
    clearInterval(this.autoSaveInterval)
  },
  methods: {
    async autoSave() {
      this.autoSaveInterval = setInterval(() => {
        this.saveQuestionnaire('save')
      }, 5 * 60 * 1000)
    },
    async getShowAfterData() {
      let id = this.$route.params.id
      let query = `{
        recursiveQuestion(
          by:
          showAfterQuestion
          base_where:{
            showAfterQuestion:{
              id:{
                neq: null
              }
            }
          }
          where:{
            questionSubject:{
              questionnaire:{
                customerQuestionnaires:{
                  id:{
                    eq: ${id}
                  }
                }
              }
            }
          }
          take:200
        ){
            results{
              id
              questionCode
              question
              showOnAnsweroptions{
                id
              }
              showAfterQuestion{
                id
                questionCode
                question
              }
            }
          }
        }`
      let result = await helpers.fetchGraph(query)
      if (result) {
        let arr = []
        let obj = result.data[Object.keys(result.data)[0]]
        for (let index = 0; index < obj.results.length; index++) {
          const element = obj.results[index]
          if (element.showAfterQuestion != null) arr.push(element)
        }
        this.showAfterQuestionArr = arr
      }
    },
    async getQuestionnaireData() {
      let id = this.$route.params.id
      let query = `{
        oneCustomerquestionnaire(where:{id:{eq:${id}}}){
          id
          status
          answers{
            id
            answerValue
            answerOptions{
              id
              optionValue
            }
            remarks
            question{
              id
              questionSubject{
                id
              }
            }
          }
          customer{
            id
            relationNumber
          }
          questionnaire{
            name
            questionnaireCode
            numberOfQuestions
            questionSubjects{
              id
              name
              description
              active
              orderIndex
              questions{
                id
                technicalCode
                orderIndex
                active
                extraInformation
                helpText
                question
                questionCode
                questionType
                required
                showOnAnsweroptions{
                  id
                }
                answerOptions{
                  id
                  orderIndex
                  defaultSelected
                  displayStr
                  optionValue
                }
              }
            }
          }
        }
      }`
      let result = await helpers.fetchGraph(query)
      // Creating the active question array
      if (result.data.oneCustomerquestionnaire === null)
        this.$router.push({ path: `/${this.countrycode}/questionnaires` })
      if (result) this.CreateQuestionnaire(result.data[Object.keys(result.data)[0]])
    },
    updateExplanation(el) {
      for (let i = 0; i < this.activeQuestionnaire.questionnaire.questionSubjects.length; i++) {
        const subject = this.activeQuestionnaire.questionnaire.questionSubjects[i]
        for (let e = 0; e < subject.questions.length; e++) {
          const q = subject.questions[e]
          if (q.id === el.question.id) {
            if (q.answers) {
              q.answers[0].remarks = el.explanation
            } else {
              q.explanation = el.explanation
            }
          }
        }
      }
    },
    async insertLastQuestion(question) {
      this.splitCurrentQuestionnaire(question)
      this.addAnswer(question)
      this.allowFinish = true
    },
    CreateQuestionnaire(fetchObj) {
      if (fetchObj) {
        // Set activeQuestionnaire meta data
        this.fetchedQuestionnaire = fetchObj
        this.activeQuestionnaire.id = fetchObj.id
        this.activeQuestionnaire.status = fetchObj.status
        this.client.id = fetchObj.customer ? fetchObj.customer.id : null
        this.client.number = fetchObj.customer ? fetchObj.customer.relationNumber : null

        if (fetchObj.questionnaire) {
          this.activeQuestionnaire.questionnaire.name = fetchObj.questionnaire.name
          this.activeQuestionnaire.questionnaire.numberOfQuestions = fetchObj.questionnaire.numberOfQuestions
          this.activeQuestionnaire.questionnaire.questionnaireCode = fetchObj.questionnaire.questionnaireCode
        }

        // Set firstSubject
        let firstSubject = fetchObj.questionnaire.questionSubjects[0]
        this.activeQuestionnaire.questionnaire.questionSubjects.push({
          id: firstSubject.id,
          name: firstSubject.name,
          description: firstSubject.description,
          orderIndex: firstSubject.orderIndex,
          questions: []
        })

        // If there are answers
        if (fetchObj.answers.length !== 0) {
          this.fillQuestionnaireOnMount(fetchObj)
        } else {
          // Set firstQuestion
          let firstQuestion = fetchObj.questionnaire.questionSubjects[0].questions[0]
          this.activeQuestionnaire.questionnaire.questionSubjects[0].questions.push(firstQuestion)
        }
      }
    },
    findQuestion(answer) {
      for (let i = 0; i < this.fetchedQuestionnaire.questionnaire.questionSubjects.length; i++) {
        const localSubject = this.fetchedQuestionnaire.questionnaire.questionSubjects[i]
        for (let e = 0; e < localSubject.questions.length; e++) {
          const localQuestion = localSubject.questions[e]
          if (localQuestion.id === answer.question.id) return localQuestion
        }
      }
    },
    async fillQuestionnaireOnMount(fetchObj) {
      if (fetchObj) {
        for (let i = 0; i < fetchObj.answers.length; i++) {
          const answer = fetchObj.answers[i]

          if (answer.answerOptions[0]) {
            answer.id = answer.answerOptions[0].id
          }

          // Checking if last question
          if (i + 1 == fetchObj.answers.length) {
            if (answer.answerOptions[0]) {
              const lastQuestionId = answer.id
              const questionnaireId = this.$route.params.id
              let query = `{
                            oneQuestion(where:{_and:[
                              {questionSubject:{questionnaire:{customerQuestionnaires:{id:{eq:${questionnaireId}}}}}},
                              {showOnAnsweroptions:{id:{eq: ${lastQuestionId}}}}
                            ]}){
                              id
                            }
                          }`
              let result = await helpers.fetchGraph(query)
              if (result.data.oneQuestion === null) {
                this.allowFinish = true
              }
            }
          }

          // add next question
          const existingSubject = this.activeQuestionnaire.questionnaire.questionSubjects.findIndex(
            subject => subject.id === answer.question.questionSubject.id
          )
          // Find question in fetched array
          let question = this.findQuestion(answer)

          if (existingSubject != -1) {
            // If existing subject, add question to it and fill in answer
            this.activeQuestionnaire.questionnaire.questionSubjects[existingSubject].questions.push(question)
          } else {
            // Else create new subject and add question to it
            let subject
            for (let i = 0; i < this.fetchedQuestionnaire.questionnaire.questionSubjects.length; i++) {
              const localSubject = this.fetchedQuestionnaire.questionnaire.questionSubjects[i]
              if (localSubject.id === answer.question.questionSubject.id) subject = localSubject
            }
            let localSubject = {
              id: subject.id,
              name: subject.name,
              description: subject.description,
              active: subject.active,
              orderIndex: subject.orderIndex,
              questions: []
            }
            // Add question to it
            this.activeQuestionnaire.questionnaire.questionSubjects.push(localSubject)
            this.activeQuestionnaire.questionnaire.questionSubjects[
              this.activeQuestionnaire.questionnaire.questionSubjects.length - 1
            ].questions.push(question)
          }
          // add answer
          question.answers = []
          question.answers.push(answer)
        }
      }
    },
    async insertNextQuestion(question) {
      //Disable finish button
      this.allowFinish = false
      if (question.result) {
        // Check if last question
        let lastQuestion = await this.checkIfLastQuestion(question)

        if (lastQuestion.last) {
          const existingSubject = this.activeQuestionnaire.questionnaire.questionSubjects.findIndex(
            subject => subject.id === question.result.questionSubject.id
          )
          this.addAnswer(question)

          if (existingSubject != -1) {
            this.activeQuestionnaire.questionnaire.questionSubjects[existingSubject].questions.push(question.result)
          } else {
            // Else add new subject and add question to it
            let localSubject = {
              id: question.result.questionSubject.id,
              name: question.result.questionSubject.name,
              description: question.result.questionSubject.description,
              active: question.result.questionSubject.active,
              orderIndex: question.result.questionSubject.orderIndex,
              questions: []
            }
            this.activeQuestionnaire.questionnaire.questionSubjects.push(localSubject)
            this.activeQuestionnaire.questionnaire.questionSubjects[
              this.activeQuestionnaire.questionnaire.questionSubjects.length - 1
            ].questions.push(question.result)
          }
        } else {
          this.splitCurrentQuestionnaire(question)
        }
      } else {
        let questionId = question.question.id
        let showAfterQ
        for (let i = 0; i < this.showAfterQuestionArr.length; i++) {
          const el = this.showAfterQuestionArr[i]
          if (questionId == el.showAfterQuestion.id) {
            showAfterQ = el
          }
        }

        let displayBasedOnArr = []
        if (showAfterQ) {
          displayBasedOnArr = showAfterQ.showOnAnsweroptions
        }

        let localDisplayBasedOnArr = []
        for (let i = 0; i < displayBasedOnArr.length; i++) {
          const element = displayBasedOnArr[i]
          localDisplayBasedOnArr.push(element.id)
        }
        let givenAnsArr = []
        for (let e = 0; e < this.activeQuestionnaire.questionnaire.questionSubjects.length; e++) {
          const localSubject = this.activeQuestionnaire.questionnaire.questionSubjects[e]
          for (let i = 0; i < localSubject.questions.length; i++) {
            const q = localSubject.questions[i]
            let obj = q.answers[0] ? q.answers[0].id : ''
            givenAnsArr.push(obj)
          }
        }
        let containsBool = false

        for (let i = 0; i < givenAnsArr.length; i++) {
          const el = givenAnsArr[i]
          let contains = localDisplayBasedOnArr.findIndex(element => element === el)
          if (contains != -1) containsBool = true
        }
        if (containsBool) {
          let q = `{
            oneQuestion(where:{id:{eq: ${showAfterQ.id}}}){
              id
              orderIndex
              active
              extraInformation
              helpText
              question
              questionCode
              questionType
              required
              showAfterQuestion{
                id
                question
              }
              showOnAnsweroptions{
                id
                optionValue
              }
              answerOptions{
                id
                orderIndex
                defaultSelected
                displayStr
                optionValue
              }
              questionSubject{
                id
                name
                description
                active
                orderIndex
              }
              technicalCode
            }
          }`
          let result = await helpers.fetchGraph(q)
          if (result) {
            this.insertNextQuestion({
              question: question.question,
              answerOption: question.answerOption,
              explanation: question.explanation,
              result: result.data.oneQuestion
            })
          }
        }
      }
    },
    addAnswer(question) {
      if (question) {
        for (let e = 0; e < this.activeQuestionnaire.questionnaire.questionSubjects.length; e++) {
          const localSubject = this.activeQuestionnaire.questionnaire.questionSubjects[e]
          for (let i = 0; i < localSubject.questions.length; i++) {
            const q = localSubject.questions[i]
            if (q.id === question.question.id) {
              q.answers = []
              q.answers.push(question.answerOption)
              if (question.explanation != '') q.explanation = question.explanation
            }
          }
        }
      }
    },
    checkIfLastQuestion(question) {
      if (question) {
        let subjects = this.activeQuestionnaire.questionnaire.questionSubjects
        let subjectsLength = this.activeQuestionnaire.questionnaire.questionSubjects.length

        // Start loop through subjects
        for (let i = 0; i < subjectsLength; i++) {
          const subject = subjects[i]

          // If last subject start loop through questions
          if (i + 1 == subjectsLength) {
            let questions = subject.questions
            let questionsLength = subject.questions.length

            // Start loop through questions
            for (let e = 0; e < questionsLength; e++) {
              const arrQuestion = questions[e]

              // If last subject start loop through questions
              if (e + 1 == questionsLength) {
                if (arrQuestion.id == question.question.id)
                  return {
                    last: true,
                    subject: subject,
                    question: arrQuestion,
                    answer: question.answerOption
                  }
                else
                  return {
                    last: false,
                    subject: subject,
                    question: arrQuestion,
                    answer: question.answerOption
                  }
              }
            }
          }
        }
      }
    },
    splitCurrentQuestionnaire(question) {
      // Loop through all active Q subjects
      let subjects = this.activeQuestionnaire.questionnaire.questionSubjects
      for (let i = 0; i < subjects.length; i++) {
        const subject = subjects[i]
        // Loop through all active Q questions per subject
        for (let e = 0; e < subject.questions.length; e++) {
          const subjectQuestion = subject.questions[e]

          if (subjectQuestion.id === question.question.id) {
            // Splice the array
            this.activeQuestionnaire.questionnaire.questionSubjects[i].questions.splice(e + 1)
            this.activeQuestionnaire.questionnaire.questionSubjects.length = i + 1

            // Remove current answer, will be replaced with the new answer
            this.activeQuestionnaire.questionnaire.questionSubjects[i].questions[e].answers = []

            // Insert next question
            this.insertNextQuestion(question)
          }
        }
      }
    },
    async saveQuestionnaire(val) {
      if (val) {
        this.$store.commit('general/SET_LOADING', { state: true })
        let response, finish
        let answersArr = []
        const id = this.activeQuestionnaire.id
        if (val === 'finish') finish = true
        else finish = false

        for (let i = 0; i < this.activeQuestionnaire.questionnaire.questionSubjects.length; i++) {
          const subject = this.activeQuestionnaire.questionnaire.questionSubjects[i]
          for (let e = 0; e < subject.questions.length; e++) {
            const question = subject.questions[e]

            let answerOptionArr = []
            if (question.answers && question.answers[0]) {
              let answerOption
              for (let a = 0; a < question.answers.length; a++) {
                if (question.answers[a].answerOptions && question.answers[a].answerOptions[0]) {
                  answerOption = question.answers[a].answerOptions[0]
                  answerOptionArr.push(answerOption.id)
                } else {
                  answerOption = question.answers[a]
                  answerOptionArr.push(answerOption.id)
                }
              }
            }

            let answerExplanation = ''
            if (question.explanation) {
              answerExplanation = question.explanation
            } else if (question.answers && question.answers[0]) {
              answerExplanation = question.answers[0].remarks
            }

            answersArr.push({
              free_text: question.answers && question.answers[0] ? question.answers[0].optionValue : null,
              remarks: answerExplanation,
              type: question.questionType,
              technical_code: question.technicalCode,
              customer_questionnaire_id: this.activeQuestionnaire.id,
              question_id: question.id,
              answer_id: question.answers && question.answers.length[0] ? question.answers[0].id : null,
              answeroption_ids: answerOptionArr.length > 0 ? answerOptionArr : null
            })
          }
        }
        let questionnaire_answers = {
          answers: answersArr
        }

        response = await helpers.fetchApi(config.apiUrl + `questionnaires/${id}`, 'put', {
          finish: finish,
          questionnaire_answer: questionnaire_answers
        })
        if (response.statusCode == 200) {
          this.$store.commit('general/SET_LOADING', { state: false })
          this.$store.commit('general/SET_SNACKBAR', {
            msg: response.message,
            status: ' white',
            color: 'success'
          })
          if (finish) {
            setTimeout(() => {
              this.$router.push({ path: `/${this.countrycode}/reporting-obligation/${id}` })
            }, 1000)
          }
        }
      }
    },
    async getReviewers() {
      let id = this.$route.params.id
      let response = await helpers.fetchApi(config.apiUrl + `/customer-questionnaire/${id}/reviewers`, 'get')
      if (response) {
        this.reviewers = response.reviewers
      }
    },
    async selectReviewer() {
      let response
      this.selectingReviewer = true
      let id = this.$route.params.id
      response = await helpers.fetchApi(config.apiUrl + `/customer-questionnaire/${id}/set-reviewer`, 'put', {
        reviewer_id: this.selectedReviewer.id
      })
      if (response.statusCode == 200) {
        this.$store.commit('general/SET_LOADING', { state: false })
        this.$store.commit('general/SET_SNACKBAR', {
          msg: response.message,
          status: ' white',
          color: 'success'
        })
      } else {
        this.selectingReviewer = false
        this.$store.commit('general/SET_LOADING', { state: false })
        this.$store.commit('general/SET_SNACKBAR', {
          msg: response.message,
          status: ' white',
          color: 'error'
        })
      }
      setTimeout(() => {
        this.$router.push({ path: `/${this.countrycode}/questionnaires` })
      }, 1000)
    },
    async endReview() {
      let response
      this.endingReview = true
      let id = this.$route.params.id
      response = await helpers.fetchApi(config.apiUrl + `/customer-questionnaire/${id}/end-review`, 'get')
      if (response.statusCode == 200) {
        this.$store.commit('general/SET_LOADING', { state: false })
        this.$store.commit('general/SET_SNACKBAR', {
          msg: response.message,
          status: ' white',
          color: 'success'
        })
      } else {
        this.selectingReviewer = false
        this.$store.commit('general/SET_LOADING', { state: false })
        this.$store.commit('general/SET_SNACKBAR', {
          msg: response.message,
          status: 'white',
          color: 'error'
        })
      }
      setTimeout(() => {
        this.$router.push({ path: `/${this.countrycode}/questionnaires` })
      }, 1000)
    },
    toOverview() {
      this.$router.push({ path: `/${this.countrycode}/questionnaires` })
    },
    toReport() {
      this.$router.push({ path: `/${this.countrycode}/reporting-obligation/${this.$route.params.id}` })
    }
  }
}
</script>

<style lang="scss">
.v-expansion-panel-header {
  border-radius: 0;
}
.v-expansion-panel:before {
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
}
</style>
<style lang="scss" scoped>
.question-subject-wrapper {
  border: 1px solid #ddd;
}
.questionnaire-overview {
  & .questionnaire-title {
    font-size: 16px;
  }
}

.questionnaire-footer {
  padding: 0 12px 16px;
  & .review {
    justify-content: flex-end;
  }
}

.modal-title {
  border-bottom: 1px solid #e5e5e5;
}
.modal-content {
  margin-top: 30px;
}
</style>
